import { CustomLink } from "../../../custom-link";
import { connect } from "react-redux";
import React from "react";
import get from "lodash/get";
import omit from "@babel/runtime/helpers/objectWithoutProperties";
import PropTypes from "prop-types";
import { SvgHandler } from "../../../svg-handler/svg-handler";
import { breakpoint } from "../../../../../utils/breakpoint";
import downArrowIcon from "../../../../../assets/icons/down-arrow.svg";
import "./menu.m.css";

function MenuLink(props) {
  const { title, completeUrl, isExternalLink } = get(props, ["item"], {});

  return React.createElement(
    CustomLink,
    {
      href: completeUrl,
      ...(isExternalLink && { externalLink: completeUrl }),
      ...omit(props, ["item"])
    },
    title
  );
}

MenuLink.propTypes = {
  item: PropTypes.object
};

class MenuBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChild: null
    };
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
  }

  toggleSubmenu(e) {
    e.stopPropagation();
    e.preventDefault();
    const currentChild = Number(e.currentTarget.dataset.id);
    this.setState(function(prevState) {
      return {
        activeChild: prevState.activeChild === currentChild ? null : currentChild
      };
    });
  }
  getMenuTypeLink(item, index) {
    if (item["item-type"] === "placeholder") {
      return <span data-id={index}>{item.title}</span>;
    }
    return <MenuLink callback={this.props.closeAll} href={item.completeUrl} item={item} />;
  }
  render() {
    const { menu, count, languageDirection = "left", primarySubmenu, closeAll } = this.props;
    return (
      <ul data-menu="true" styleName="menu">
        {menu.slice(0, count).map((item, index) => {
          if (item.children.length) {
            return (
              <li
                data-id={index}
                styleName={`menu-item has-child ${index === this.state.activeChild ? "submenu-open" : ""}`}
                key={`${item["id"]}${index}`}
              >
                {this.getMenuTypeLink(item, index)}
                {breakpoint("tablet") && (
                  <span href="#" styleName="arrow" onClick={this.toggleSubmenu} data-id={index}>
                    <SvgHandler width="24px" height="24px" xlinkHref={downArrowIcon} />
                  </span>
                )}
                <ul
                  data-submenu="true"
                  styleName={`sub-menu ${
                    breakpoint("tablet") ? (index === this.state.activeChild ? "open" : "close") : ""
                  } ${languageDirection === "right" ? "sub-menu-rtl" : ""} ${
                    index === primarySubmenu && breakpoint("tablet") ? "open-submenu" : ""
                  }`}
                >
                  {item.children.map((child, index) => {
                    return (
                      <li styleName="sub-menu-item" key={`${child["id"]}${index}`}>
                        <MenuLink callback={closeAll} item={child} />
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          }

          return (
            <li styleName="menu-item" key={`${item["id"]}${index}`}>
              {item["item-type"] === "placeholder" ? (
                <span>{item.title}</span>
              ) : (
                <MenuLink callback={closeAll} item={item} />
              )}
            </li>
          );
        })}
      </ul>
    );
  }
}

MenuBase.propTypes = {
  menu: PropTypes.object,
  count: PropTypes.number,
  closeAll: PropTypes.func,
  primarySubmenu: PropTypes.number,
  openPrimarySubmenu: PropTypes.func,
  closePrimarySubmenu: PropTypes.func,
  languageDirection: PropTypes.string
};

const mapStateToProps = state => {
  return {
    primarySubmenu: get(state, ["footer", "primarySubmenu"])
  };
};

const mapDispatchToProps = dispatch => ({
  openPrimarySubmenu: menuId => dispatch({ type: "OPEN_PRIMARY_SUBMENU", payload: { menuId } }),
  closePrimarySubmenu: () => dispatch({ type: "CLOSE_PRIMARY_SUBMENU" })
});

export const Menu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuBase);
